// Login / Forgotten password toggle
$(".forgotten-pass, .loginfrom-link").on("click", function(e) {
  e.preventDefault();
  const $this = $(this);
  const targetString = $this.attr("href").replace("#", "");
  $(`.${targetString}`).show();
  $this.closest("form").parent().hide();
});

if (window.location.hash === "#form--recover" && $("body").hasClass("template-customer--login")) {
  $(".form--recover").show();
  $(".form--login").hide();
}

// Address new
$(".addresses__actions .btn--new, .form--address-new .btn--cancel").on("click", function(e) {
  e.preventDefault();
  const $this = $(this);
  const targetString = $this.attr("href").replace("#", "");
  $(`.${targetString}`).toggle();
  $("html,body").animate({
    scrollTop: $(".main .section__inner").offset().top - $(".header__inner").outerHeight()
  });
});

// Collection sortBy
$("#sortBy").on("change", function() {
  Shopify.queryParams = {};
  const $this = $(this);
  const thisVal = $this.val();

  if (location.search) {
    const getArgumentsArray = location.search.substr(1).split("&");
    getArgumentsArray.map(function(ele) {
      const eleArray = ele.split("=");
      Shopify.queryParams[decodeURIComponent(eleArray[0])] = decodeURIComponent(eleArray[1]);
    });
  }

  Shopify.queryParams.sort_by = thisVal;
  location.search = jQuery.param(Shopify.queryParams);
});

// Product price update
$("#product-select").on("change", function() {
  const $this = $(this);
  const thisPrice = $this.find("option:selected").data("price");
  const $form = $this.closest("form");
  $(".product__price").html(thisPrice);
  if (!$this.val()) {
    $form.find(".form__btn").hide();
    $("#BIS_trigger").add($(".unavailable")).show();
  } else {
    $form.find(".form__btn").show();
    $("#BIS_trigger").add($(".unavailable")).hide();
  }
});

// Address province option
$('select[name="address[country]"]').each(function() {
  const $this = $(this);
  const thisID = $this.attr("id");
  const province = $this.closest("form").find('select[name="address[province]"]');
  const provinceID = province.attr("id");
  const provinceHolderID = province.closest(".form__row").attr("id");
  new Shopify.CountryProvinceSelector(thisID, provinceID, {
    hideElement: provinceHolderID
  });
});



// WEBPACK FOOTER //
// ../assets/js/base/index.js